import * as v from "valibot";

import { MEMBERS_QUERY } from "@/features/members/graphql/members-query";
import { Members } from "@/features/members/members";
import { MEMBER_VIEWS } from "@/features/members/schema";

const views = [
  MEMBER_VIEWS.ACTIVE,
  MEMBER_VIEWS.DISABLED,
  MEMBER_VIEWS.INVITATIONS,
  MEMBER_VIEWS.REQUESTS,
];
const searchSchema = v.object({
  view: v.optional(v.picklist(views), MEMBER_VIEWS.ACTIVE),
});

export const Route = createFileRoute({
  component: Members,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(MEMBERS_QUERY, { organizationId: params.orgId }).toPromise();
    }
  },
  validateSearch: searchSchema,
});
